import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '@ng-darwin/config';

/**
 * @description Injectable
 * @class HttpRequestInterceptor
 * @implements {HttpInterceptor} HttpInterceptor
 */
@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  /**
   * @description Creates an instance of HttpRequestInterceptor.
   * @param _configService ConfigService
   */
  constructor(private readonly _configService: ConfigService) {}

  /**
   * @description intercept
   * @param req HttpRequest<any>
   * @param next HttpHandler
   * @returns Observable<HttpEvent<any>>
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    let headers: any;
    if (
      sessionStorage.getItem('app-unique-id') ===
      this._configService.config.app['cdncApplication']
    ) {
      headers = req.clone({
        headers: req.headers
          .set(
            'app-clientid',
            this._configService.config.app['cdncApplication'],
          )
          .set('authorization', 'Bearer ' + sessionStorage.getItem('_dwtk')),
      });
    } else {
      // For normal clients, Darwin Security handles auth via session cookies.
      // However, in webview mode after cross-domain navigation to the bank,
      // cookies are lost and securityService.initialize() fails. In that case
      // we fall back to the _dwtk token restored from localStorage backup,
      // and must send it explicitly as a Bearer token.
      const isWebview = sessionStorage.getItem('iswebview') === 'true';
      const token = sessionStorage.getItem('_dwtk');
      let reqHeaders = req.headers.set(
        'app-clientid',
        this._configService.config.appKey,
      );
      if (isWebview && token) {
        reqHeaders = reqHeaders.set('authorization', 'Bearer ' + token);
      }
      headers = req.clone({ headers: reqHeaders });
    }
    return next.handle(headers);
  }
}
